import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollPageToTop } from "../../utils/scrollToTop";

/** Rota veya ilan id değişince sayfa başına kaydırır. */
const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();

  useLayoutEffect(() => {
    scrollPageToTop();
  }, [pathname, search, key]);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return null;
};

export default ScrollToTop;
